import React, { Component, useState, useCallback } from 'react';

import { connect } from 'react-redux';

import {
  Img,
  Title,
  Subtitle,
  Subsubtitle,
  GreyTitle,
  BasicText,
  HoriBlock,
  VertiBlock,
  VertiTableBlock,
  HoriTableBlock,
  Text,
  CensusList
} from '../dumb_component/PageComponent.js';

import { DATABASE } from '../backend/model';
import store from '../redux/store.js';
import { setDisplayIslandBlock } from '../redux/Actions'

function round(value, precision) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

class IslandPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fakeIsland: {},
      structure: {}
    }
  };

  componentDidMount() {

    const unsubscribe = store.subscribe((a) => {
      if(this.props.isAdmin != store.getState().userReducer.isAdmin){
        console.log('Force update')
        let structure = this.updateStructure(store.getState().userReducer.isAdmin)
        this.setState({ structure })
      }
        
    });

    let structure = this.updateStructure()

    this.setState({
      structure,
      unsubscribe
    });
  }

  componentWillUnmount() {
    this.state.unsubscribe();
  }

  updateStructure = (isAdmin = this.props.isAdmin) => {
    /**
     * Test if island contains info relative to blocks. If not, block doesn't display.
     * The fields key can be omitted if the table is present in only one block
     */
    let structure = {
      main: isAdmin ? true : this.structureChecker([{table: 'NOM_ILOTS'}, {table: 'DESCRIPTION_GEO'}, {table: 'PERTURBATION_ANTHROPIQUE', fields: ['CAPACITES_D_ACCES']}, {table: 'STATUS_FONCIER', fields: ['COMMUNES']}]),
      pmf: isAdmin ? true : this.structureChecker([{table: 'STATUS_FONCIER', fields: ['DOMAINE', 'PROPRIETAIRES', 'GESTIONNAIRE']}]),
      protect: isAdmin ? true : this.structureChecker([{table: 'RNN'}, {table: 'RNR'}, {table: 'RNCFS'}, {table: 'N_2000'}, {table: 'PNR'}, {table: 'PNM'}, {table: 'APB'}, {table: 'SITE_CLASSE_INSCRIT'}, {table: 'GRAND_SITE'}]),
      gestion: isAdmin ? true : this.structureChecker([{table: 'GESTION'}]),
      geomorph: isAdmin ? true : this.structureChecker([{table: 'GEOMORPHOLOGIE_GEOLOGIE'}]),
      occupHistoMain: isAdmin ? true : this.structureChecker([{table: 'ARCHEO_HISTORIQUE', fields: ['DESCRIPTION']}]),
      occupHistoSide: isAdmin ? true : this.structureChecker([{table: 'ARCHEO_HISTORIQUE', fields: ['INVENTAIRE_ARCHEO', 'BATI_HISTO', 'MONU_HISTO']}]),
      perdioModernMain: isAdmin ? true : this.structureChecker([{table: 'PERTURBATION_ANTHROPIQUE', fields: ['DESCRIPTION']}]),
      periodModernSide: isAdmin ? true : this.structureChecker([{table: 'PERTURBATION_ANTHROPIQUE', fields: ['FREQ_HUMAINE', 'ACTEUR_LOCAUX', 'DERANGEMENT', 'CAPACITES_D_ACCES']}]),
      habitat: isAdmin ? true : this.structureChecker([{table: 'HABITAT'}]),
      flore: isAdmin ? true : this.structureChecker([{table: 'FLORE'}]),
      floreInva: isAdmin ? true : this.structureChecker([{table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FLORE', 'NOM_SCI_FLORE', 'DATE_OBS_FLORE']}]),
      faune: isAdmin ? true : this.structureChecker([{table: 'INVERTEBRE'}, {table: 'REPTILE'}, {table: 'MAMMIFERE'}]),
      faunePatri: isAdmin ? true : this.structureChecker([{table: 'FAUNE'}]),
      fauneInva: isAdmin ? true : this.structureChecker([{table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FAUNE', 'NOM_SCI_FAUNE', 'DATE_OBS_FAUNE']}]),
      recensDec: isAdmin ? true : this.censusChecker({table: 'OISEAUX_MARINS_NICHEURS', lookFor: ['R_D_MOY', 'RESULT_SUIVIS']}),
      oismar: isAdmin ? true : this.censusChecker({table: 'OISEAUX_MARINS_NICHEURS', lookFor: ['NOM_VERN']}),
      autresSp: isAdmin ? true : this.censusChecker({table: 'AUTRES_SP_AVIF', lookFor: ['RESULT']}),
      wetland: isAdmin ? true : this.censusChecker({table: 'WETLAND', lookFor: ['EFF_WETLAND_MIN']}),

    }

    structure = { ...structure, occupHum: this.structureContainerChecker([structure.occupHistoMain, structure.occupHistoSide, structure.periodModernMain, structure.periodModernSide])};
    structure = { ...structure, occupSide: this.structureContainerChecker([structure.occupHistoSide, structure.periodModernSide])};
    structure = { ...structure, patri: this.structureContainerChecker([structure.habitat, structure.flore, structure.floreInva, structure.faune, structure.faunePatri, structure.fauneInva, structure.recensDec, structure.oismar, structure.autresSp, structure.wetland])};
    structure = { ...structure, census: this.structureContainerChecker([structure.recensDec, structure.oismar, structure.autresSp, structure.wetland])}
    
    return structure
  }

  structureContainerChecker = (array) => {
    return array.some(e => !!e)
  }

  structureChecker = (array) => {
    if(this.props.isAdmin)
      return true;
    const { island } = this.props;
    let keys = Object.keys(this.props.island);
    let informationIsPresent = false;
    
    for(let i = 0; i < array.length; i++) {
      if(keys.includes(array[i].table)){
        if(!!array[i].fields) {
          if(!!island[array[i].table]) {
            for(let ii = 0; ii < array[i].fields.length; ii++) {
              if(!!island[array[i].table][array[i].fields[ii]]) {
                informationIsPresent = true;
                break;
              }
            }
          }
        }
        else {
          informationIsPresent = true;
          break;
        }
      }
    }

    return informationIsPresent;
  }

  censusChecker = ({table, lookFor} = obj) => {
    
    if(this.props.isAdmin)
      return true;
      
    const { island } = this.props;
    let informationIsPresent = false;


    if(!!island[table]) {
      let keys = Object.keys(island[table]);
      for(let ii = 0; ii < lookFor.length; ii++) {
        for(let i = 0; i < keys.length; i++) {
          if(!!island[table][keys[i]][lookFor[ii]]) {
            informationIsPresent = true;
            break;
          }
        }
      }
    }
    return informationIsPresent;
  }

  changeHandler = (table, field, text) => {
    this.props.changeData(table, field, text);
  }

  // HOC component giving access to this.props.island
  _ = (WrappedComponent, changeHandler = (table, field, text) => this.changeHandler(table, field, text)) => {

    let isAdmin = this.props.isAdmin;
    const island = this.props.island;
    // Fake island :
    /*let fakeIsland = {};
    Object.keys(DATABASE).forEach(key => {
      fakeIsland[key] = {};
      Object.keys(DATABASE[key]).forEach(innerKey => {
        fakeIsland[key][innerKey] = innerKey
      })
    });*/

    /*const checkOnContent = (children) => {
      console.log('checkOnContent called with :', children)
      const fn = (t, f) => {
        console.log('fn called with :', t, f)
        if(!!island[t])
          return island[t][f];
      };

      const fnData = (line) => {
        console.log('fnData called with :', line)
        if(Array.isArray(line[1]))
          return line[1].map(l => fnData(l))
        return line[1].fields.map(l => fn(line[1].table, l));
      };
      
      if(!Array.isArray(children)){
        console.log('.', children);
        if(!!children.props.children)
          return checkOnContent(children.props.children)
        if(!!children.props.data)
          return children.props.data.map(line => {
            return fnData(line);
          });
      }

      return children.map(child => {
        console.log('..', child)
        if(child.type == 'HoriBlock')
          return checkOnContent(child);
        else if(!!child.props.data)
          return child.props.data.map(line => {
            return fnData(line);
          });
        else if(!!child.props.children)
          return checkOnContent(child.props.children)
        else
          return fn(child.props.table, child.props.field)
      });
    }*/

    return class extends Component {
      constructor(){
        super();
      }
      render() {
        // console.log('Wrapped component : ', WrappedComponent, 'Wrapped component prop\'s :', this.props)
        const { table, field, data, children, handleChange } = this.props;
        let cName = WrappedComponent.name;
        let src = undefined;

        if(isAdmin) {
          if(!!table && island[table] != undefined)
            src = island[table][field];
          else if (!!table == 'IMAGES' && island[table] == undefined)
            src = undefined;
          else 
            src = island;
        } else {
          if(!!table && island[table] != undefined)
            src = island[table][field];
          else if (!!table == 'IMAGES' && island[table] == undefined)
            src = undefined;
          else
            src = island;
        }
        if(JSON.stringify(src) === JSON.stringify(""))
          src = undefined

        if(field == 'SURFACE_HISTOLITT' && src != undefined) {
          src = round(src, 1);
        }
        return <WrappedComponent name={WrappedComponent.name} isAdmin={isAdmin} id={`${table}:::${field}`} src={src} {...this.props} handleChange={ !!handleChange ? handleChange : (table, field, text) => changeHandler(table, field, text)}/>;
      };
    };
  };

  render() {
    console.log('island info from IslandPage:', this.props.island, this.state, this.props);
    const { structure } = this.state
    const { island } = this.props;

    const _BasicText = this._(BasicText);
    const _Img = this._(Img);
    const _VertiTableBlock = this._(VertiTableBlock);
    const _HoriTableBlock = this._(HoriTableBlock);
    const _CensusList = this._(CensusList);

    return(
      <div id='page-island' style={{ flexDirection: 'column', padding: 15, marginBottom: 15, overflowX: 'hidden' }}>
        <HoriBlock>
          <VertiBlock flex={2} show={structure.main} padding={30}>
            <HoriBlock>
              <_BasicText desc={'Nom IGN'} table={'NOM_ILOTS'} field={'IGN'} maj/>
              <_BasicText desc={'Autre nom'} table={'NOM_ILOTS'} field={'NOM_2'} />
            </HoriBlock>
            <_BasicText desc={'Nom archipel'} table={'DESCRIPTION_GEO'} field={'NOM_ARCHIPEL'} />
            <_BasicText desc={'Commune'} table={'STATUS_FONCIER'} field={'COMMUNES'}/>
            <_BasicText desc={'Coordonnée X'} table={'DESCRIPTION_GEO'} field={'COORD_X'} />
            <_BasicText desc={'Coordonnée Y'} table={'DESCRIPTION_GEO'} field={'COORD_Y'} />
            <_BasicText desc={'Type'} table={'DESCRIPTION_GEO'} field={'TYPE_ILOT'}/>
            <_BasicText desc={'Surface'} table={'DESCRIPTION_GEO'} field={'SURFACE_HISTOLITT'}/>
            <_BasicText desc={'Surface d\'estran associé'} table={'DESCRIPTION_GEO'} field={'SURFACE_ESTRAN_ASSOCIEE'}/>
            <_BasicText desc={'Altitude'} table={'DESCRIPTION_GEO'} field={'ALTITUDE_MAX_SHOM'}/>
            <_BasicText desc={'Distance de la côte'} table={'DESCRIPTION_GEO'} field={'DISTANCE_COTE'}/>
            <_BasicText desc={'Île / îlot principal'} table={'DESCRIPTION_GEO'} field={'RATTACH_ILOT_PRINCIPAL'}/>
            <_BasicText desc={'Orientation'} table={'DESCRIPTION_GEO'} field={'ORIENTATION'}/>
            <_BasicText desc={'Débarquement'} table={'PERTURBATION_ANTHROPIQUE'} field={'CAPACITES_D_ACCES'}/>
          </VertiBlock>
          <_Img id='imgTopRight' table={'IMAGES'} field={'imgTopRight'} imgHasChanged={this.props.imgHasChanged} />
        </HoriBlock>
        <HoriBlock>
          <_Img id='imgBottomLeft' table={'IMAGES'} field={'imgBottomLeft'} imgHasChanged={this.props.imgHasChanged}/>
          <_Img id='imgBottomRight' table={'IMAGES'} field={'imgBottomRight'} imgHasChanged={this.props.imgHasChanged}/>
        </HoriBlock>
        <HoriBlock show={structure.pmf}>
          <VertiBlock title='Propriété / maitrise foncière' padding={30}>
            <_BasicText desc={'Domaine'} table={'STATUS_FONCIER'} field={'DOMAINE'}/>
            <_BasicText desc={'Propriétaire'} table={'STATUS_FONCIER'} field={'PROPRIETAIRES'}/>
            <_BasicText desc={'Maitrise foncière / usage'} table={'STATUS_FONCIER'} field={'GESTIONNAIRE'}/>
          </VertiBlock>
        </HoriBlock>
        <HoriBlock show={structure.protect}>
          <VertiBlock title='Protection réglementaire & contractuelle / Inventaire' padding={30}>
            <_VertiTableBlock
              nbOfColumns={5}
              data={[
                ['RNN', {table: 'RNN', fields: ['RNN', 'CODE_RNN', 'DATE', 'GESTIONNAIRE']}],
                ['RNR', {table: 'RNR', fields: ['RNR', 'CODE_RNR', 'DATE', 'GESTIONNAIRE']}],
                ['RNCFS', {table: 'RNCFS', fields: ['RNCFS', 'CODE_RNCFS', 'DATE', 'GESTIONNAIRE']}],
                ['N 2000 ZPS', {table: 'N_2000', fields: ['ZPS', 'CODE_ZPS', 'DATE_ZPS', 'OPERATEUR_ZPS']}],
                ['N 2000 ZSC', {table: 'N_2000', fields: ['ZSC', 'CODE_ZSC', 'DATE_ZSC', 'OPERATEUR_ZSC']}],
                ['PNR', {table: 'PNR', fields: ['PNR', 'CODE_PNR', 'DATE', 'OPERATEUR']}],
                ['PNM', {table: 'PNM', fields: ['PNM', 'CODE_PNM', 'DATE', 'OPERATEUR']}],
                ['APPB', {table: 'APB', fields: ['APB', 'CODE_APB', 'DATE', 'OPERATEUR']}],
                ['Site classé', {table: 'SITE_CLASSE_INSCRIT', fields: ['NOM_CLASSE', 'CODE_CLASSE']}],
                ['Site inscrit', {table: 'SITE_CLASSE_INSCRIT', fields: ['NOM_INSCRIT', 'CODE_INSCRIT']}],
                ['Grand site', {table: 'GRAND_SITE', fields: ['SITE', 'DATE', 'GESTIONNAIRE']}],
              ]} />
          </VertiBlock>
        </HoriBlock>
        <HoriBlock show={structure.gestion}>
          <VertiBlock title='Gestion' padding={30}>
            <_BasicText desc={'Type d\'accord'} table={'GESTION'} field={'TYPE_D_ACCORD'}/>
            <_BasicText desc={'Surveillance et présence sur le site'} table={'GESTION'} field={'SURVEILLANCE_PRESENCE'}/>
            <_BasicText desc={'Plan de gestion'} table={'GESTION'} field={'PDG'}/>
            <_BasicText desc={'Type de gestion'} table={'GESTION'} field={'TYPE_GESTION'}/>
            <_BasicText desc={'Action de gestion annuelle'} table={'GESTION'} field={'ACTION_GESTION_ANNUEL'}/>
            <_BasicText desc={'Plan de gestion'} table={'GESTION'} field={'PERIODE'}/>
          </VertiBlock>
        </HoriBlock>
        <HoriBlock show={structure.geomorph}>
          <VertiBlock title='Description géomorphologique' padding={30}>
            <_BasicText desc={'Description'} table={'GEOMORPHOLOGIE_GEOLOGIE'} field={'DESCRIPTION'} multiline/>
            <_BasicText desc={'Formation d\'intérêt'} table={'GEOMORPHOLOGIE_GEOLOGIE'} field={'FORM_INTERET'}/>
          </VertiBlock>
        </HoriBlock>
        <VertiBlock title='Occupation humaine' show={structure.occupHum} padding={30}>
          <HoriBlock>
            <VertiBlock subtitle='Occupation historique' show={structure.occupHisto} padding={0} flex={2}>
              <HoriBlock>
                <VertiBlock flex={1.5} padding={0} show={structure.occupHistoMain}>
                  <_BasicText desc={''} table={'ARCHEO_HISTORIQUE'} field={'DESCRIPTION'} multiline/>
                </VertiBlock>
                <VertiBlock show={structure.occupHistoSide} padding={0}>
                  <_BasicText desc={'Inventaire archéologique'} table={'ARCHEO_HISTORIQUE'} field={'INVENTAIRE_ARCHEO'} display='inline-block'/>
                  <_BasicText desc={'Batiment historique'} table={'ARCHEO_HISTORIQUE'} field={'BATI_HISTO'} display='inline-block'/>
                  <_BasicText desc={'Monument historique'} table={'ARCHEO_HISTORIQUE'} field={'MONU_HISTO'} display='inline-block'/>
                </VertiBlock>
              </HoriBlock>
            </VertiBlock>
          </HoriBlock>
          <HoriBlock>
            <VertiBlock subtitle='Période moderne' show={structure.periodModern} padding={0} flex={2}>
              <HoriBlock>
                <VertiBlock flex={1.5} padding={0}>
                  <_BasicText desc={''} table={'PERTURBATION_ANTHROPIQUE'} field={'DESCRIPTION'} multiline/>
                </VertiBlock>
                <VertiBlock show={structure.periodModernSide} padding={0}>
                  <_BasicText desc={'Fréquentation humaine'} table={'PERTURBATION_ANTHROPIQUE'} field={'FREQ_HUMAINE'} display='inline-block'/>
                  <_BasicText desc={'Acteurs locaux'} table={'PERTURBATION_ANTHROPIQUE'} field={'ACTEUR_LOCAUX'} display='inline-block'/>
                  <_BasicText desc={'Dérangement'} table={'PERTURBATION_ANTHROPIQUE'} field={'DERANGEMENT'} display='inline-block'/>
                  <_BasicText desc={'Capacité d\'accueil'} table={'PERTURBATION_ANTHROPIQUE'} field={'CAPACITES_D_ACCES'} display='inline-block'/>
                </VertiBlock>
              </HoriBlock>
            </VertiBlock>
          </HoriBlock>
        </VertiBlock>
        <HoriBlock>
          <VertiBlock title='Patrimoine naturel et intérêt patrimonial' subtitle='Espèces' show={structure.patri} padding={30}>
            <VertiBlock show={structure.habitat} padding={0}>
              <Subsubtitle text='Directive Habitats' />
              <_BasicText desc={'Description'} table={'HABITAT'} field={'DESCRIPTION'} multiline/>
              <_HoriTableBlock
                data={[
                  ['Habitat', {table: 'HABITAT', fields: ['NOM_HABITAT']}],
                  ['Code EUNIS', {table: 'HABITAT', fields: ['CODE_EUNIS']}],
                  ['Code EU', {table: 'HABITAT', fields: ['CODE_EU']}],
              ]}/>
            </VertiBlock>
            <VertiBlock show={structure.flore} padding={0}>
              <Subsubtitle text='Flore' />
              <_BasicText desc={'Description'} table={'FLORE'} field={'DESCRIPTION'} multiline/>
              <GreyTitle text='Flore patrimoniale' />
              <_HoriTableBlock
                data={[
                  ['Espèce', [
                    ['Nom Vern', {table: 'FLORE', fields: ['NOM_VERN']}],
                    ['Nom Sci', {table: 'FLORE', fields: ['NOM_SCI']}],
                  ]],
                  ['Protection FR', {table: 'FLORE', fields: ['PROT_NAT']}],
                  ['Dir. Hab.', {table: 'FLORE', fields: ['DIR_HAB']}],
                  ['Liste Rouge FR', {table: 'FLORE', fields: ['LR_NAT']}],
                  ['LR Massif Armo.', {table: 'FLORE', fields: ['LR_MASSIF_ARMO']}],
                ]}/>
            </VertiBlock>
            <VertiBlock show={structure.floreInva} padding={0}>
              <GreyTitle text='Flore invasive / introduite' />
              <_VertiTableBlock
                data={[
                  ['', {table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FLORE', 'NOM_SCI_FLORE', 'DATE_OBS_FLORE']}],
                ]} />
            </VertiBlock>
            <VertiBlock show={structure.faune} padding={0}>
              <Subsubtitle text='Faune' />
              <_BasicText desc={'Invertébrés'} table={'INVERTEBRE'} field={'DESCRIPTION'} multiline/>
              <_BasicText desc={'Reptiles'} table={'REPTILE'} field={'DESCRIPTION'} multiline/>
              <_BasicText desc={'Mammifères'} table={'MAMMIFERE'} field={'DESCRIPTION'} multiline/>
            </VertiBlock>
            <VertiBlock show={structure.faunePatri} padding={0}>
              <GreyTitle text='Faune patrimoniale' />
              <_HoriTableBlock
                data={[
                  ['Espèce', [
                    ['Nom Vern', {table: 'FAUNE', fields: ['NOM_VERN']}],
                    ['Nom Sci', {table: 'FAUNE', fields: ['NOM_SCI']}],
                  ]],
                  ['Protection FR', {table: 'FAUNE', fields: ['PROT_NAT']}],
                  ['Dir. Hab.', {table: 'FAUNE', fields: ['DIR_HAB']}],
                  ['Liste Rouge FR', {table: 'FAUNE', fields: ['LR_NAT']}],
                  ['LR Régionale', {table: 'FAUNE', fields: ['LR_REG']}],
                ]}/>
            </VertiBlock>
            <VertiBlock show={structure.fauneInva} padding={0}>
              <GreyTitle text='Faune invasive / introduite' />
              <_VertiTableBlock
                data={[
                  ['', {table: 'ESPECES_INTRODUITES', fields: ['NOM_VERN_FAUNE', 'NOM_SCI_FAUNE', 'DATE_OBS_FAUNE']}],
                ]} />
            </VertiBlock>
            <VertiBlock show={structure.census} padding={0}>
              <GreyTitle text='Avifaune' />
              <_BasicText desc={'Description'} table={'AUTRES_SP_AVIF'} field={'DESCRIPTION'} multiline/>

              <_CensusList 
                displayLR={false}
                title={'Oiseaux marins nicheurs'}
                censusData={island.OISEAUX_MARINS_NICHEURS}
                census={'OISEAUX_MARINS_NICHEURS'}
                show={structure.oismar}
                displayLR={ false } />
            </VertiBlock>
          </VertiBlock>
        </HoriBlock>
      </div>
    );
  };
};

const mapStateToProps = state => {
  const { isAdmin } = state.userReducer;
  return {isAdmin}
}
export default connect(mapStateToProps, {})(IslandPage)

/*

              <_CensusList 
                title={'Recensement décennal'}
                censusData={island.OISEAUX_MARINS_NICHEURS}
                census={'OISEAUX_MARINS_NICHEURS'}
                decennal
                show={structure.recensDec} />

*/